import React from 'react';
import { SubInterestCategory } from '@src/containers/QuizContainer/types';
import { InterestCheckBox } from '../InterestCheckBox';
import styles from './InterestCheckBoxSet.module.scss';

export interface Props {
	interests: SubInterestCategory[];
	onSelect: (interests: string[]) => void;
	selections: string[];
}

export const InterestCheckBoxSet: React.FC<Props> = props => {
	const handleClick = (interest: string) => {
		if (props.selections.includes(interest)) {
			const interests = props.selections.filter(i => i !== interest);
			props.onSelect(interests);
		} else {
			const interests = [...props.selections, interest];
			props.onSelect(interests);
		}
	};

	return (
		<div className={styles.wrapper}>
			{props.interests.map(interest => (
				<div className={styles.checkboxSpacing} key={interest.name}>
					<InterestCheckBox
						checked={props.selections.includes(interest.facet)}
						label={interest.name}
						onChange={() => handleClick(interest.facet)}
						popoverText={interest.description}
					/>
				</div>
			))}
		</div>
	);
};
